import { CloseIcon } from "components/atoms/Icon";
import EditImageButton from "../atoms/EditImage";
import Label from "../atoms/forms/Label";

type Props = {
  label: string;
  id: string;
  imageURL: string;
  setFieldValue: (file: FileList, id: string) => void;
  image?: any;
  additionalClasses?: string;
  labelClasses?: string;
  handleClearImageButton: () => void;
};

function ImageEditElement({
  label,
  id,
  imageURL,
  image,
  setFieldValue,
  additionalClasses,
  labelClasses,
  handleClearImageButton,
}: Props) {
  const renderClearImageButton = image;
  return (
    <div className={additionalClasses}>
      <Label htmlFor={id} label={label} labelClasses={labelClasses} />
      <div className="relative mt-2 h-52 w-full rounded-xl border-1 border-secondary border-opacity-30">
        {renderClearImageButton && (
          <button type="button" className="absolute right-0 p-2" onClick={handleClearImageButton}>
            <CloseIcon className="h-4 w-4 text-white" />
          </button>
        )}
        <img
          className="h-full w-full rounded-xl object-cover"
          src={image ? URL.createObjectURL(image) : imageURL}
          alt={label}
        />
        <EditImageButton id={id} setFieldValue={setFieldValue} />
      </div>
    </div>
  );
}
export default ImageEditElement;
